function getTimeRemaining(endtime) {
    let t = Date.parse(endtime) - Date.parse(new Date());
    let seconds = Math.floor((t / 1000) % 60);
    seconds = (seconds < 0) ? 0 : seconds
    // console.log(seconds)

    let minutes = Math.floor((t / 1000 / 60) % 60);
    minutes = (minutes < 0) ? 0 : minutes

    let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    hours = (hours < 0) ? 0 : hours

    let days = Math.floor(t / (1000 * 60 * 60 * 24));
    days = (days < 0) ? 0 : days

    return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
    };
}

function initializeClock(el, endtime) {
    let clock = el;
    let daysSpan = clock.querySelector('.countdown-timer-days');
    let hoursSpan = clock.querySelector('.countdown-timer-hours');
    let minutesSpan = clock.querySelector('.countdown-timer-minutes');
    let secondsSpan = clock.querySelector('.countdown-timer-seconds');

    let daysSvg = clock.querySelector('.count-down-circle-days');
    let hoursSvg = clock.querySelector('.count-down-circle-hours');
    let minutesSvg = clock.querySelector('.count-down-circle-minutes');
    let secondsSvg = clock.querySelector('.count-down-circle-seconds');

    function updateClock() {
        let t = getTimeRemaining(endtime);

        daysSpan.textContent = t.days;
        hoursSpan.textContent = ('0' + t.hours).slice(-2);
        minutesSpan.textContent = ('0' + t.minutes).slice(-2);
        secondsSpan.textContent = ('0' + t.seconds).slice(-2);

        // let's assume the svg circle has a radius of 50
        // circumference = 2π × 50 ≈ 314.16
        // a full circle is 314.16
        // so 1 second is 314.16 / 60 ≈ 5.236
        // then set stroke-dashoffset to 5.236 * seconds

        let radius = 40;
        if(el.attributes['data-radius']) {
            radius = el.attributes['data-radius'].value;
        }
        let circumference = 2 * Math.PI * radius;

        let offsetSecond = circumference - (circumference / 60 * t.seconds);
        let offsetMinutes = circumference - (circumference / 60 * t.minutes);
        let offsetHours = circumference - (circumference / 24 * t.hours);
        let offsetDays = t.days > 0 ? 0 : circumference;


        secondsSvg.style.strokeDashoffset = offsetSecond + '';
        minutesSvg.style.strokeDashoffset = offsetMinutes + '';
        hoursSvg.style.strokeDashoffset = offsetHours + '';
        daysSvg.style.strokeDashoffset = offsetDays + '';

        // console.log(secondsSpan.innerHTML)
        if (t.total <= 0) {
            window.location.reload();
            clearInterval(timeInterval);
        }
    }

    updateClock();
    let timeInterval = setInterval(updateClock, 1000);
}

let countdownTimers = document.querySelectorAll('.countdown-timer');
countdownTimers.forEach(function (timer) {
    let deadline = new Date(Date.parse(timer.getAttribute('data-deadline')));
    initializeClock(timer, deadline);
});
